const DEFAULT_API_BASE = '/'

function ensureTrailingSlash(url) {
  if (!url) return '/'
  return url.endsWith('/') ? url : `${url}/`
}

export function getApiBase() {
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return ensureTrailingSlash(window.location.origin)
  }
  return ensureTrailingSlash(process.env.VUE_APP_API_URL || DEFAULT_API_BASE)
}

export function getApiPath(path = '') {
  const normalizedPath = String(path || '').replace(/^\/+/, '')
  return `${getApiBase()}${normalizedPath}`
}
